import { render, staticRenderFns } from "./SidebarSwitchItem.vue?vue&type=template&id=626c8fa1&"
import script from "./SidebarSwitchItem.vue?vue&type=script&lang=js&"
export * from "./SidebarSwitchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports